import { HomeWrap } from "./HomeWrap";
import band1600 from "@/assets/home-band-1600.jpg";
import band800 from "@/assets/home-band-800.jpg";

/**
 * Full bleed photo band between the hero and the problem section.
 *
 * The scrim is the design's, unchanged: the photo sits at opacity .58 over
 * #1C130C, with a left to right gradient from .92 to .5 on top. Both are load
 * bearing for the text contrast over the image, so neither is lightened.
 */
export function HomeBand() {
  return (
    <section className="relative h-[clamp(300px,38vw,460px)] overflow-hidden bg-[#1C130C]">
      <img
        src={band1600}
        srcSet={`${band800} 800w, ${band1600} 1600w`}
        sizes="100vw"
        alt="A café in Los Angeles on a weekday afternoon, tables full of people working on laptops."
        loading="lazy"
        width={1600}
        height={516}
        className="h-full w-full object-cover object-[center_62%] opacity-[.58]"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[linear-gradient(to_right,rgba(28,19,12,.92)_0%,rgba(28,19,12,.66)_48%,rgba(28,19,12,.5)_100%)]"
      />
      <div className="absolute inset-0 flex items-center">
        <HomeWrap>
          <h2 className="max-w-[24ch] font-display text-[clamp(26px,3.4vw,40px)] font-semibold leading-[1.12] tracking-[-0.015em] text-[#F6EFE4]">
            Four hours, a laptop, and a table that has to work
          </h2>
          <p className="mt-[14px] max-w-[36ch] text-[16.5px] text-[#BFA88E]">
            That is the afternoon Grounded is built for.
          </p>
        </HomeWrap>
      </div>
    </section>
  );
}
